require('./bootstrap');
require('./utils/alarms');
require('./utils/tooltip');
require('./utils/select2');
require('./utils/json_view')
require('./websocket');
require('./components');
require('./events');
require('./charts');
require('./chat');

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';

import Inputmask from "inputmask/lib/inputmask";
import Components from "./components";
import { render } from './components/editor';

window.Components = Components;
window.Alpine = Alpine;
window.Inputmask = Inputmask;
window.wysiwygInit = render;

Alpine.plugin(intersect);
Alpine.start();
